import NudosRadioButton from 'components/NudosRadioButton/NudosRadioButton';
import { formatShortDate } from 'utils/formatDatesAndHours';
import useStockReservationState from 'state/useStockReservationState';
import { NudosHoverText } from 'components/NudosComponents';

import './SelectReservationSerialItem.scss';

interface ISelectReservationSerialItem {
  providerName: string;
  serial: string;
  billingNumber: string;
  date: string;
  stockProductId: number;
  isFirtsOut: boolean;
  isSelected: boolean;
  onSelect: () => void;
}

const SelectReservationSerialItem = ({
  providerName,
  serial,
  billingNumber,
  date,
  stockProductId,
  isFirtsOut,
  isSelected,
  onSelect
}: ISelectReservationSerialItem) => {
  const { setSelectedItems, currentSingleSaleId } = useStockReservationState();

  const handleSelectSerial = () => {
    onSelect();
    setSelectedItems([{ stockProductId: stockProductId, saleId: currentSingleSaleId }]);
  };

  return (
    <div className="selectReservationSerialItem">
      <div className="selectReservationSerialItemContainer">
        <div className="radioButtonContainer">
          <NudosRadioButton isButtonActive={isSelected} handleClickButton={handleSelectSerial} componentSize="small" />
          <div className="serialAndProviderContainer">
            <div className="serialContainer">
              <div className="serial">Serial:</div>
              <NudosHoverText text={serial} charactersLimit={20} />
            </div>
            <div className="providerName">Proveedor: {providerName}</div>
          </div>
        </div>
        <div className="billingNumberContainer">
          <div className="billingNumber">Factura: {billingNumber}</div>
        </div>
        <div className="dateContainer">
          {isFirtsOut && <div className="firstOut">(Primero por salir)</div>}
          <div className="date">Fecha: {formatShortDate(date)?.onlyDate ?? ''}</div>
        </div>
      </div>
      <div className="grayLine" />
    </div>
  );
};

export default SelectReservationSerialItem;
